class GIconSearch extends HTMLElement {
  connectedCallback() {
    this.innerHTML = '<svg class="g-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M17.5 35C7.9 35 0 27.1 0 17.5S7.9 0 17.5 0 35 7.9 35 17.5 27.1 35 17.5 35zm0-34C8.4 1 1 8.4 1 17.5S8.4 34 17.5 34 34 26.6 34 17.5 26.6 1 17.5 1z"/><path d="M49.5 50c-.1 0-.3 0-.4-.1L29.3 30.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l19.8 19.8c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z"/></svg>';
  }
}

if (!customElements.get('g-icon-search')) {
  customElements.define('g-icon-search', GIconSearch);
}
